import { render, staticRenderFns } from "./addAdmin.vue?vue&type=template&id=6f28655c"
import script from "./addAdmin.vue?vue&type=script&lang=js"
export * from "./addAdmin.vue?vue&type=script&lang=js"
import style0 from "./addAdmin.vue?vue&type=style&index=0&id=6f28655c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports